export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
}
